import "./SubscriptionInformation.css"
import "./SubscriptionInformationGradients.css"
import {COMPLEMENTARY_PRODUCTS, gradientGetter, SubscriptionStatus} from "../../utils";
import {useTranslation} from "react-i18next";
import {Button} from "@mui/material";
import React, {useRef} from "react";
import {useNavigate} from "react-router-dom";
import CouponInformationComponent from "./components/CouponInformationComponent";
import CurrentInformationComponent from "./components/CurrentInformationComponent";
import BillingInformationComponent from "./components/BillingInformationComponent";
import {useFlexWrapDetection} from "./components/FlexWrapDetection";
import VillageVoucherInformationComponent from "./components/VillageVoucherInformationComponent";
import AddonInformationComponent from "./AddonSection/AddonInformationComponent";

function SubscriptionInformation({userData, canUpgrade, hasFreeProduct, hasUnsubscribed, periodEndDate, hasUsedCoupon, addonEligible, updateUserData, setErrorPopup}){

    let navigate = useNavigate();
    const { t } = useTranslation();

    const containerRef = useRef(null);
    const { wrappedIndices } = useFlexWrapDetection(containerRef);

    return <>
    {!!userData?.subscription ?
        <div className={"subscriptionInformation-container"}>
            <div className={`subscriptionInformation ${gradientGetter(userData?.subscription?.product?.name)}`}>
                <div
                    ref={containerRef}
                    className={"section-wrapper"}>
                    <div className={"section-heading"}>
                        <span className={"heading-title"}>
                            {t("accountProductTitle")}
                        </span>
                        <SubscriptionInformationFlowComponent
                            userData={userData} periodEndDate={periodEndDate}
                            {...{
                            hasUpgradeCTA: ((!hasUnsubscribed && (hasFreeProduct || canUpgrade)) && userData?.subscription?.state !== "canceled" && (userData?.subscription?.status !== SubscriptionStatus.ActiveInGrace)),
                            unsubscribed: {
                                hasUnsubscribed: (hasUnsubscribed && !hasFreeProduct) || userData?.subscription?.state === "canceled" || userData?.subscription?.state === "final_bill",
                                isCanceled: userData?.subscription?.state === "canceled",
                                isFinalBill: userData?.subscription?.state === "final_bill"
                            },
                            showBillingInfo: !hasFreeProduct && (userData?.renewalPreview?.next_assessment_at),
                            showPackageDuration: !((hasUnsubscribed && !hasFreeProduct) || userData?.subscription?.state === "canceled" || userData?.subscription?.state === "final_bill") && !hasFreeProduct && userData?.renewalPreview?.next_assessment_at && userData?.subscription?.state,
                            isPassedDue: userData?.subscription?.state === "past_due",
                            isScheduledDowngrade: !!userData?.subscription?.next_product_price_point_id,
                            shouldShowCancelButton: (!hasUnsubscribed && !hasFreeProduct &&
                                    userData?.subscription?.state !== "canceled" &&
                                    userData?.subscription?.state !== "past_due") &&
                                !COMPLEMENTARY_PRODUCTS.includes(userData?.subscription?.product?.name)
                        }}/>
                    </div>
                    <CouponInformationComponent
                        wrapped={wrappedIndices.includes(1)}
                                                userData={userData}
                                                showCouponSection={userData?.subscription?.state !== "canceled" &&
                                                        (userData?.subscription?.status !== SubscriptionStatus.ActiveCancelled &&
                                                        userData?.subscription?.status !== SubscriptionStatus.ActiveInGrace)}
                                                showCurrentCoupons={!hasUnsubscribed && !hasFreeProduct && hasUsedCoupon}/>
                </div>
            </div>
            <AddonInformationComponent userData={userData} addonEligible={addonEligible} updateUserData={updateUserData} setErrorPopup={setErrorPopup}/>
        </div>
        : //case subscription service failure
        <>
            <div
                className={`subscriptionInformation-box ${gradientGetter(userData?.subscription?.product?.name)}`}>
                <div className={"subscriptionInformation-service-error"}>
                    {t("subServiceErrorAccount")}
                    <Button variant="contained"
                            color="primary"
                            onClick={() => {
                                navigate(0)
                            }}
                            id="refresh page">
                        {t("subServiceErrorCTA")}
                    </Button>
                </div>
            </div>
        </>
        }
    </>
}


const SubscriptionInformationFlowComponent = ({userData, hasUpgradeCTA, unsubscribed, showBillingInfo, showPackageDuration,
                                                  isPassedDue, isScheduledDowngrade, shouldShowCancelButton, periodEndDate}) =>{
    const {t} = useTranslation();
    const getProgramDuration = (interval, capitilized) =>{
        if(interval === 1){
            return capitilized ? t("accountProductCurrentIntervalMonthlyCapitalized"): t("accountProductCurrentIntervalMonthly")
        }
        return t("accountProductCurrentIntervalMulti", {interval: interval})
    }
    return (<>
        <div className={"section-current-product"}>
            <CurrentInformationComponent userData={userData} hasUpgradeCTA={hasUpgradeCTA}/>
            {showPackageDuration ?
                <span className={"current-product-duration"}>
                                        {getProgramDuration(userData?.subscription?.product.interval, true)} {t("accountProductCurrentIntervalSubscription")}
                                    </span>
                :
                <></>
            }
            <BillingInformationComponent userData={userData} isScheduledDowngrade={isScheduledDowngrade} shouldShowCancelButton={shouldShowCancelButton} isPassedDue={isPassedDue} showBillingInfo={showBillingInfo} unsubscribed={unsubscribed} />
            <VillageVoucherInformationComponent userData={userData} periodEndDate={periodEndDate} />
        </div>
    </>)
}

export default SubscriptionInformation;